import Discussion from 'shared/components/discussion';
import { SEND_CHAT_MESSAGE_URL } from 'commons/Utils/UrlBuilder'
import AhoyEvent from 'shared/ahoy_event';
import SocketAPI from 'vidio-chat';

export default class EmojiTable {
  constructor({$element: $element}) {
    this.$element = $element;
    this.selector = {
      chatForm: '#new_comment',
      button: '.livestreaming-discussion__table-button',
      chatBox: '.livestreaming-discussion__input',
      tableContainer: ".livestreaming-discussion__table",
      stickerContainer: '.livestreaming-discussion__table-sticker',
      emojiContainer: '.livestreaming-discussion__table-emoji',
      stickerItem: '.livestreaming-discussion__table-item-sticker',
      emojiItem: '.livestreaming-discussion__table-item-emoji',
      stickerPack: '.livestreaming-discussion__table-sticker__single',
      stickerPackImage: '.livestreaming-discussion__table-sticker__single img',
    };
    this.ui = {};

    this.stickerPrioritize = [
      "semangat", "hebat", "indonesia", "juara"
    ];

    this.stickerBola = [
      "sedih", "ayo", "gol", "pelanggaran", "kartumerah", "sriwijaya", "mitrakukar", "persija", "arema", "maduraunited", "persib", "perseru", "semenpadang", "psm", "pusamania", "baliunited", "persegres", "persipura", "barito", "surabayaunited", "persiba", "pstni", "persela"
    ];

    this.stickerCandy = [
      'candyangry', 'candybirthday', 'candybored', 'candybroke', 'candydizzy', 'candydontcare', 'candygrumpy', 'candyhi', 'candyhurray', 'candyidea', 'candykiss', 'candylaugh', 'candylove', 'candymakeup', 'candysad', 'candysick', 'candysorry', 'candythanks', 'candywait', 'candywink'
    ];

    this.stickerCotton = [
      'cottonangel', 'cottonbequiet', 'cottonblush', 'cottoncallme', 'cottoncold', 'cottonconfused', 'cottondevil', 'cottonembarrassed', 'cottonfire', 'cottongrin', 'cottongrumpy', 'cottonhi', 'cottonhot', 'cottonjawdrop', 'cottonlaugh', 'cottonletsgo', 'cottonlove', 'cottonmad', 'cottonno', 'cottonokay', 'cottononmyway', 'cottonpickafight', 'cottonraisehand', 'cottonsad', 'cottonshock', 'cottonsick', 'cottonsigh', 'cottonsleep', 'cottonthumbsdown', 'cottonthumbsup', 'cottonyawn', 'cottonyikes'
    ];

    this.stickerList = [].concat(this.stickerPrioritize, this.stickerBola, this.stickerCandy, this.stickerCotton);

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });

    this.discussion = new Discussion();
  }

  init() {
    this.ui.button.click(this.onClick.bind(this));
    this.bindStickerPackClick();
    $(this.ui.stickerPackImage).first().click();
    $('.livestreaming-discussion__submit.ga__livestreaming__submit-comment').on('click', this.hideEmojiTable.bind(this));
  }

  onClick() {
    if ( this.ui.tableContainer.hasClass('hide-me') ) {
      this.showEmojiTable();
    } else {
      this.hideEmojiTable();
    }
  }

  showEmojiTable() {
    this.ui.tableContainer.removeClass('hide-me');
    this.ui.button.data('action', 'view emoticon');
  }

  hideEmojiTable() {
    this.ui.tableContainer.addClass('hide-me');
    this.ui.button.data('action', 'close emoticon');
  }

  stickerInjector(evt) {
    if (window.stickerLists == undefined) {
      return;
    }

    let key = $(evt.target).data("pack");
    let pack_name = $(evt.target).data("pack-name");
    let stickerItems = window.stickerLists[key];

    $(this.selector.stickerItem).remove();
    stickerItems.forEach((item) => {
      var sticker = `<span class="livestreaming-discussion__table-item-sticker sticker sticker-${item} ga__livestreaming-sticker-item" data-name="${item}" data-pack-name="${pack_name}"></span>`;
      this.ui.stickerContainer.append(sticker);
    });
    this.bindStickerClick();
  }

  bindStickerClick() {
    $(this.selector.stickerItem).on('click', this.stickerSubmit.bind(this));
  }

  bindStickerPackClick() {
    $(this.selector.stickerPackImage).on('click', this.stickerInjector.bind(this));
  }

  stickerSubmit(e) {
    const livestreamingId =  $('#comment_commentable_id').attr('value');
    const stickerName = $(e.target).data('name');

    var comment = {
      'livestreaming_id': livestreamingId,
      'content': stickerName
    };

    this.sendAjax(comment);
    this.sendStickerAhoyEvent(comment, 'click');
  }

  sendStickerAhoyEvent(commentData, action) {
    const stickerPackId = $(this.selector.stickerPackImage).data('pack');

    AhoyEvent.send('VIDIO::STICKER', {
      action: action,
      page: 'live',
      livestreaming_id: commentData['livestreaming_id'],
      sticker_pack_id: stickerPackId,
      sticker_id: commentData['content']
    });
  }

  sendAjax(commentData) {
    const token = SocketAPI.getToken() || {};
    const CSRFToken = document.querySelector('meta[name="csrf-token"]').content;

    $.ajax({
      method: 'POST',
      url: SEND_CHAT_MESSAGE_URL,
      data: commentData,
      headers: {
        'Authorization': `Bearer ${token.web}`,
        'X-CSRF-TOKEN': CSRFToken
      }
    }).done(data => {
      this.sendStickerAhoyEvent(commentData, 'send');
      this.renderData(data);
    });
  }

  renderData(data) {
    this.hideEmojiTable();
    this.discussion.renderNewComment(data);
  }
}
